import type { DateRange } from '../models/domain/date-range'
import { DateUtils } from './date.utils'

export class DateRangeUtils {
  static isDateRangeStartDate(dateRange: DateRange, date: Date): boolean {
    return !!dateRange.startDate && DateUtils.areDatesEqual(dateRange.startDate, date)
  }

  static isDateRangeEndDate(dateRange: DateRange, date: Date): boolean {
    return !!dateRange.endDate && DateUtils.areDatesEqual(dateRange.endDate, date)
  }

  static isDateInRange(dateRange: DateRange, date: Date): boolean {
    const dateWithoutTime = (fullDate: Date): Date => new Date(fullDate.toDateString())
    return (
      !!date &&
      !!dateRange.startDate &&
      !!dateRange.endDate &&
      dateWithoutTime(date) >= dateWithoutTime(dateRange.startDate) &&
      dateWithoutTime(date) <= dateWithoutTime(dateRange.endDate)
    )
  }

  static isDateRangeEmpty(dateRange: DateRange): boolean {
    return !dateRange.startDate
  }

  static isDateRangeComplete(dateRange: DateRange): boolean {
    return !!dateRange.startDate && !!dateRange.endDate
  }

  static updateDateRange(dateRange: DateRange, date: Date): DateRange {
    if (this.isDateRangeEmpty(dateRange) || this.isDateRangeComplete(dateRange)) {
      return {
        startDate: date,
      }
    }

    if (!!dateRange.startDate && date > dateRange.startDate) {
      return {
        ...dateRange,
        endDate: date,
      }
    }

    return {
      startDate: date,
      endDate: dateRange.startDate,
    }
  }
}
